export default __webpack_public_path__ + "static/media/user.9eab2a92.png";